import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {ChartParams} from "app/views/chart/chart.component";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import { ChartModel } from "app/models/chart.model";
import {PaymentStructureDetailComponent} from "./details/details.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {PeriodService} from "../../views/period/period.service";
import { BillingService2 } from "../billing.service";
import { ICharts, IStatResult } from "../../models/responce_result.model";
import { FilterParams } from "../../models/filter_form.model";

interface IPaymentStructureChart extends ICharts {
	categories: object[];
	tariffVariantList?: object[];
	tariffIdList?: object[];
}


interface IDisturbData extends IStatResult {
	userWithSiteCount: number;
	userWithoutSiteCount: number;
}

@Component({
	selector: 'payment-structure',
	template: `
		<cache-date></cache-date>
		
		<period></period>
		
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="tariffVariants.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('tariffVariants', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="tariffVariants.data" [options]="tariffVariants.options" [sextant]="'tariffVariants'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="tariffIds.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('tariffIds', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="tariffIds.data" [options]="tariffIds.options" [sextant]="'tariffIds'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="paymenyType.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('paymenyType', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="paymenyType.data" [options]="paymenyType.options" [sextant]="'paymenyType'"></chart>
		<hr><br>
		

		<form class="form-inline">
			<div class="form-group">
				<label>Other</label>
				<input type="number" class="form-control" placeholder="Other" [(ngModel)]="otherBorder" [ngModelOptions]="{standalone: true}" (change)="changeBorder()">
			</div>
		</form>
		<chart [data]="intervals.data" [options]="intervals.options" [sextant]="'intervals'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="currentTariffIds.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('currentTariffIds', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="currentTariffIds.data" [options]="currentTariffIds.options" [sextant]="'currentTariffIds'"></chart>
		
		<hr><br><br>
		
		<div [sextant]="'disturbData'">
			<h3>{{ 'adminstat.billing.payment_structure.disturb title' | translate }}</h3>
			<h4>{{ 'adminstat.billing.payment_structure.userWithSiteCount' | translate }}: {{ disturbData.userWithSiteCount }}</h4>
			<h4>{{ 'adminstat.billing.payment_structure.userWithoutSiteCount' | translate }}: {{ disturbData.userWithoutSiteCount }}</h4>
			
			<br>
			<table class="table" >
				<thead>
					<tr>
						<th>{{ 'adminstat.common.siteCount' | translate }}</th>
						<th>{{ 'adminstat.common.userCount' | translate }}</th>
						<th title="('adminstat.billing.payment_structure.disturb title percent' | translate)">%</th>
					</tr>
				</thead>
	
				<tbody *ngIf="disturbData">
					<tr *ngFor="let stat of disturbData.stats">
						<td>{{ stat.siteCount }}</td>
						<td>
							<button-anhor (click)="showDisturbDetails(stat)" [sextant]="'details-' + key">
								{{ stat.userCount }}
							</button-anhor>
						</td>
						<td>{{ stat.percentUserCount }}%</td>
					</tr>
				</tbody>
			</table>
			
			<loading [isLoad]="disturbLoader"></loading>
		</div>
	`,
	providers: [ChartModel]
})
export class PaymentStructureComponent extends BaseComponent {
	addFilterParams = {
		userType    : 'user',
		dateFilters : ['datePaid', 'dateCreated', 'dateSiteCreated'],
		period      : 'month',
		isBilling   : true,
	};
	
	otherBorder = 100;
	
	tariffVariants = new ChartParams({
		chartValue: 'absolute'
	});
	
	tariffIds = new ChartParams({
		chartValue: 'absolute'
	});

	paymenyType = new ChartParams({
		chartValue: 'absolute',
		type: 'bar',
		title: 'Распределение по способу оплаты (ручные оплаты)',
	});
	
	currentTariffIds = new ChartParams({
		chartValue: 'absolute'
	});
	
	intervals = new ChartParams();
	
	disturbLoader:boolean = false;
	disturbData = {
		userWithSiteCount    : 0,
		userWithoutSiteCount : 0,
		stats                : []
	};
	
	
	constructor(
		public modalService: ModalService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public periodService: PeriodService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.periodService.period = this.addFilterParams.period;
	}
	
	
	async getData() {
		await this.getTariffVariantsChart();
		await this.getTariffIdsChart();
		await this.getPaymentTypeChart();
		await this.getIntervalsChart();
		await this.getCurrentTariffIdsChart();
		await this.getDisturbTable();
	}
	
	async getPaymentTypeChart(chartValue: string = 'absolute') {
		const fp = this.filter.getCopyFilterParams({
			chartValue,
		});
		
		this.paymenyType.showLoader();
		this.tariffIds.options.chartValue = chartValue;
		
		const { charts, categories } = await this.service2.paymentStructure.chart<IPaymentStructureChart>(
			fp,
			'type/charts'
		).toPromise();
		
		this.paymenyType.data = charts;
		this.paymenyType.setOptions({
			groups: categories,
			axis: {
				y: {
					show: true,
					label: {
						text     : chartValue === 'absolute' ? 'Оплаты' : '%',
						position : 'outer-middle'
					}
				}
			},
		})

		this.paymenyType.hideLoader();
	}
	
	async getTariffVariantsChart(chartValue: string = 'absolute') {
		const fp = this.filter.getCopyFilterParams({
			chartValue,
		});
		
		this.tariffVariants.showLoader();
		this.tariffVariants.options.chartValue = chartValue;
		
		const { charts, categories, tariffVariantList } = await this.service2.paymentStructure.chart<IPaymentStructureChart>(
			fp,
			'tariff_variants'
		).toPromise();
		
		this.tariffVariants.data = charts;
		
		this.tariffVariants.setOptions({
			title: this.translate.__A('billing.payment_structure.tariff variants distribution'),
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: categories,
					tick: {
						fit: true,
					}
				}
			},
			groups: tariffVariantList
		});
		
		this.tariffVariants.hideLoader();
	}
	
	
	async getTariffIdsChart(chartValue: string = 'absolute') {
		const fp = this.filter.getCopyFilterParams({
			chartValue,
		});
		
		this.tariffIds.showLoader();
		this.tariffIds.options.chartValue = chartValue;
		
		const { charts, tariffIdList, categories } = await this.service2.paymentStructure.chart<IPaymentStructureChart>(
			fp,
			'tariff_ids'
		).toPromise();
		
		this.tariffIds.data = charts;
		
		this.tariffIds.setOptions({
			title: this.translate.__A('billing.payment_structure.tariff ids distribution'),
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: categories,
					tick: {
						culling: {
							max: 3
						}
					}
				}
			},
			groups: tariffIdList
		});
		
		this.tariffIds.hideLoader();
	}
	
	
	async getIntervalsChart() {
		const fp = this.filter.getCopyFilterParams({
			intervalOtherBorder: this.otherBorder,
		});
		
		this.intervals.showLoader();
		
		const { charts } = await this.service2.paymentStructure.chart(
			fp,
			'intervals'
		).toPromise();
		
		this.intervals.data = charts;
		
		this.intervals.setOptions({
			title: this.translate.__A('billing.payment_structure.intervals'),
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					tick: {
						culling: {
							max: 3
						}
					}
				}
			}
		});
		
		this.intervals.hideLoader();
	}
	
	
	async getCurrentTariffIdsChart(chartValue: string = 'absolute') {
		const fp = this.filter.getCopyFilterParams({
			chartValue,
			intervalOtherBorder: this.otherBorder,
		});
		
		this.currentTariffIds.showLoader();
		this.currentTariffIds.options.chartValue = chartValue;
		
		const { charts, tariffIdList, } = await this.service2.paymentStructure.chart<IPaymentStructureChart>(
			fp,
			'current_tariff_ids'
		).toPromise();
		
		this.currentTariffIds.data = charts;
		
		this.currentTariffIds.setOptions({
			title: this.translate.__A('billing.payment_structure.current tariff ids distribution'),
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: ['Total'],
					tick: {
						culling: {
							max: 3
						}
					}
				}
			},
			groups: tariffIdList
		});
		
		this.currentTariffIds.hideLoader();
	}
	
	
	async getDisturbTable() {
		this.disturbLoader = true;
		
		const {
			stats, userWithSiteCount, userWithoutSiteCount,
		} = await this.service2.paymentStructure.stats<IDisturbData>(
			this.filter.getFilterParams(),
			'disturb'
		).toPromise();
		this.disturbData.userWithSiteCount = userWithSiteCount;
		this.disturbData.userWithoutSiteCount = userWithoutSiteCount;
		this.disturbData.stats = stats;
			
		this.disturbLoader = false;
	}
	
	
	async changeChartValue(chart: string, value: string) {
		if (chart == 'tariffVariants') {
			await this.getTariffVariantsChart(value);
		}
		
		if (chart == 'tariffIds') {
			await this.getTariffIdsChart(value);
		}
		
		if (chart == 'currentTariffIds') {
			await this.getCurrentTariffIdsChart(value);
		}
		
		if (chart == 'paymenyType') {
			await this.getPaymentTypeChart(value);
		}
	}
	
	
	async changeBorder() {
		this.getIntervalsChart();
	}
	
	
	async showDisturbDetails(stat) {
		const modalRef = this.modalService.open(
			PaymentStructureDetailComponent,
			{
				title: `Site count: ${stat.siteCount}, user count: ${stat.userCount}`
			},
			{size: 'hg'}
		);
		
		const { stats } = await this.service2.paymentStructure.detail(
			this.filter.getCopyFilterParams(<FilterParams>{
				siteCount: stat.siteCount,
			}),
			'disturb/detail'
		).toPromise();

		modalRef.componentInstance.stats = stats;
	}
}
